import { render, staticRenderFns } from "./PathOverview.vue?vue&type=template&id=3d8d4670&scoped=true&"
import script from "./PathOverview.vue?vue&type=script&lang=ts&"
export * from "./PathOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PathOverview.vue?vue&type=style&index=0&id=3d8d4670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d4670",
  null
  
)

export default component.exports